import { graphql, useStaticQuery } from "gatsby";

export const GetWebsite = () => {
  const siteData = useStaticQuery(graphql`
    query getWebsiteData {
      strapiWebsite {
        HeroImages {
          url
          localFile {
            url
          }
        }
        MobileBackgroundImages {
          url
          localFile {
            url
          }
        }
        Contact {
          Contact {
            type
            children {
              type
              text
              url
              children {
                type
                text
              }
            }
          }
          Instagram
        }
        Legal {
          Imprint {
            type
            children {
              type
              text
            }
          }
          Privacy {
            type
            children {
              type
              text
            }
          }
        }
      }
    }
  `);
  return siteData.strapiWebsite;
};
